 <template>
  <div class="item-ref" v-on-clickout="()=>{dropdown=false}">
    <!--<div v-if="!$parent.popsicle && !searchterm" class="blue-txt top-marg5"  @click="addNew($attrs.validations.collectionId)">+ Add New</div>-->
    <div
      v-if="!$parent.popsicle"
      class="blue-txt top-marg5"
      @click="newItem($attrs.validations.collectionId)"
    >+ Add New</div>
    <input
      :disabled="editable!=undefined?!editable:false"
      ref="input"
      @keyup.down="setFocus(0)"
      @focus="dropdown=true"
      @input="selectify()"
      type="text"
      :placeholder="'Select '+fname"
      class="itref text-field w-input"
      :class="this.$parent.info[this.slg]?'selected':''"
      v-model="searchterm"
      maxlength="256"
    />

    <p v-if="searchterm && (editable!==false)" @click="selectify('clean')" class="link-block-2"></p>

    <div class="dropdown-list" v-if="dropdown">
      <ul class="list w-list-unstyled">
        <li
          class="ddown-list w-clearfix srf-ddown"
          v-for="(item,i) in trueFields"
          :key="item._id"
          :ref="'li'+i"
          @keydown="focusUp($event)"
          @keyup.down="()=>{setFocus(i+1)}"
          @keyup.up="()=>{setFocus(i-1)}"
          @keyup.enter="updateSelection(item._id)"
          :tabindex="i"
          @click="updateSelection(item._id)"
        >{{item.name}}</li>
      </ul>
      <loader v-if="!$parent.$parent.items[$attrs.validations.collectionId]" zoom="0.5" />
    </div>
  </div>
</template>

<script>
import loader from "@/components/loader.vue";
import { mixin as clickout } from "vue-clickout";
export default {
  name: "ItemRef",
  mixins: [clickout],
  components: { loader },
  props: ["slg", "fname", "index", "value", "editable"],
  data() {
    return {
      dropdown: false,
      relItems: [],
      searchterm: "",
      loader: true,
      Col: ""
    };
  },
  methods: {
    newItem(id) {
      this.$parent.$parent.popup =
        id + "/new-item/" + this.$props.slg + "/sngl";
    },
    focusUp(e) {
      var key = e.keyCode;
      if (key != 40 && key != 38 && key != 13) {
        this.$refs.input.focus();
      }
    },
    setFocus(i) {
      if (this.$refs["li" + i].length) {
        this.$refs["li" + i][0].focus();
      }
    },
    addNew(id) {
      this.$parent.$parent.popup =
        id + "/new-item/" + this.$props.slg + "/sngl";
    },
    selectify(clean) {
      if (clean) {
        this.searchterm = "";
      }
      if (this.$parent.info[this.slg]) {
        this.$parent.info[this.slg] = "";
      }
    },
    mountSelection() {
      if (this.$parent.info[this.slg]) {
        var item = this.relItems.find(
          e => e._id === this.$parent.info[this.slg]
        );
        this.searchterm = item.name;
      }
    },
    updateSelection(id) {
      this.$parent.info[this.slg] = id;
      this.dropdown = false;
      var item = this.relItems.find(e => e._id === this.$parent.info[this.slg]);
      this.searchterm = item.name;
    },
    getData(Col) {
      if (this.$parent.$parent.items[Col]) {
        $.each(this.$parent.$parent.items[Col], (i, e) => {
          this.relItems.push(e);
          this.loader = false;
        });
        this.mountSelection();
      } else {
        this.$parent.$parent.items[Col] = [];
        getdata.firebase(Col, res => {
          this.relItems = res;
          this.$parent.$parent.items[Col] = res;
          this.loader = false;
          this.mountSelection();
        });
      }
    },
    search(obj, child, term) {
      var include = {};
      $.each(obj, (i, e) => {
        if (e[child].match(new RegExp(term, "gi"))) {
          include[i] = e;
        }
      });
      return include;
    }
  },
  created() {
    var Col = this.$attrs.validations.collectionId;
    this.Col = Col;
    this.getData(Col);
  },
  computed: {
    topLevel() {
      return this.$parent.info[this.slg];
    },
    trueFields() {
      var regex;
      //var arr2 = this.$parent.info[this.slg]
      this.searchterm ? (regex = this.searchterm) : (regex = /./);
      var newarr = [];
      $.each(
        this.$parent.$parent.items[this.$attrs.validations.collectionId],
        (i, e) => {
          if (e.name.match(new RegExp(regex, "i")) && !e._archived) {
            newarr.push(e);
          }
        }
      );
      return newarr;
    }
  },
  watch: {
    value() {
      console.log("change");
      if (this.value && this.relItems && !this.loader) {
        this.searchterm = this.relItems.find(e => e._id === this.value).name;
      } else {
        return;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blue-txt.top-marg5 {
  margin-bottom: -30px;
  cursor: pointer;
}
.dropdown-list {
  top: 38px;
}

.link-block-2 {
  margin-top: -45px;
  margin-right: 10px;
}
</style>